import APIClient from './index';
import _ from 'lodash';

export const getUrlDataToMatch = params => {
  return new Promise((resolve, reject) => {
    APIClient.get(`UrlData`, { params })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const updateUrlData = (hashedUrlStem, data) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`UrlData/${hashedUrlStem}`, data)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getDomains = params => {
  return new Promise((resolve, reject) => {
    APIClient.get(`UrlData/domains`, { params })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getUrlDataStats = hashedUrlStem => {
  return new Promise((resolve, reject) => {
    APIClient.get(`UrlData/${hashedUrlStem}/stats`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getMatchesByUserToday = () => {
  return new Promise((resolve, reject) => {
    APIClient.get(`UrlData/history`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const reserveUrlData = hashedUrlStem => {
  return new Promise((resolve, reject) => {
    APIClient.post(`UrlData/${hashedUrlStem}/reserve`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const releaseUrlData = hashedUrlStem => {
  return new Promise((resolve, reject) => {
    APIClient.post(`UrlData/${hashedUrlStem}/release`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getIgnoredDomains = () => {
  return new Promise((resolve, reject) => {
    APIClient.get(`UrlData/ignored-domains`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const addIgnoredDomain = domain => {
  return new Promise((resolve, reject) => {
    APIClient.post(`UrlData/ignored-domains`, { domain })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const deleteIgnoredDomain = id => {
  return new Promise((resolve, reject) => {
    APIClient.delete(`UrlData/ignored-domains/${id}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getUrlDataOverrides = (domain, hashedUrlStem) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`UrlData/overrides`, { params: { domain, hashedUrlStem } })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const updateUrlDataOverrides = (domain, urlStem, hashedUrlStem, overrides) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`UrlData/overrides`, { domain, urlStem, hashedUrlStem, overrides })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const bulkManageUrlData = ({ links, action, postAction }) => {
  return new Promise((resolve, reject) => {
    APIClient.post(`UrlData/bulk`, { links, action, postAction })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getUrlDataExplore = params => {
  return new Promise((resolve, reject) => {
    APIClient.get(`UrlData/explore`, { params })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getUrlDataExploreDetail = id => {
  return new Promise((resolve, reject) => {
    APIClient.get(`UrlData/${id}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const previewProductSinkDetach = ({ Product_id, domain }) => {
  return new Promise((resolve, reject) => {
    APIClient.post(`UrlData/product-sinks/preview`, { Product_id, domain })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const startProductSinkDetach = ({ Product_id, domain, excludedUrlDataIds, routeIgnoredDomains }) => {
  return new Promise((resolve, reject) => {
    APIClient.post(`UrlData/product-sinks/detach`, { Product_id, domain, excludedUrlDataIds, routeIgnoredDomains })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const revertProductSinkAgentMatches = runId => {
  return new Promise((resolve, reject) => {
    APIClient.post(`UrlData/product-sinks/runs/${runId}/revert-agent-matches`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getProductSinkDetachRuns = params => {
  return new Promise((resolve, reject) => {
    APIClient.get(`UrlData/product-sinks/runs`, { params })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getUrlDataReports = params => {
  return new Promise((resolve, reject) => {
    APIClient.get(`UrlDataReports`, { params })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const updateUrlDataReport = (id, updates) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`UrlDataReports/${id}`, updates)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const requeueUrlDataReport = id => {
  return new Promise((resolve, reject) => {
    APIClient.post(`UrlDataReports/${id}/requeue`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
